import { Preferences, ResponseError } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { FETCH_SIZE_PREFERENCES_REQUEST, FETCH_SIZE_PREFERENCES_SUCCESS, FETCH_SIZE_PREFERENCES_ERROR } from '../constants/ActionTypes'
import { push } from 'connected-react-router'

function fetchSizesRequest() {
    return {
        type: FETCH_SIZE_PREFERENCES_REQUEST
    }
}

function fetchSizesSuccess(sizePreferences) {
    return {
        type: FETCH_SIZE_PREFERENCES_SUCCESS,
        payload: sizePreferences
    }
}

function fetchSizesError() {
    return {
        type: FETCH_SIZE_PREFERENCES_ERROR
    }
}

export default function fetchSizes() {
    return (dispatch, getState, fetch) => {
        const { locale, config, router = {} } = getState()
        const { country } = locale
        const { location = {} } = router 
        const { pathname } = location
        const { clientRequest } = config.head || config
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        const request = Preferences.getSizePreferences({ baseUrl, brandId, country, clientId })

        dispatch(fetchSizesRequest())

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response

                if (ok) {
                    return response.json().then((json) => dispatch(fetchSizesSuccess(json)))
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                }

                throw new ResponseError(response)
            })
            .catch((error) => {
                dispatch(fetchSizesError(error))
                throw error
            })
    }
}
